module.exports = __webpack_public_path__ + "static/student_connect.8b674840.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/student_connect.jpg
// module id = 584
// module chunks = 179562081087140